import { render } from "./PaymentRequestModal.vue?vue&type=template&id=be959b34&scoped=true&ts=true"
import script from "./PaymentRequestModal.vue?vue&type=script&lang=ts"
export * from "./PaymentRequestModal.vue?vue&type=script&lang=ts"

import "./PaymentRequestModal.vue?vue&type=style&index=0&id=be959b34&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be959b34"]])

export default __exports__